<div class="header_second">
    <div class="Dashboard_head ">Product Category
        <button mat-raised-button style="background-color:#dd484b; 
                color:#fff;                                       
                font-size: 12px;
                margin-right: 15px;" (click)="AddScanningPoint()">Add Category</button>
    </div>
</div>


<div class="mat-elevation-z8 m-1">
    <mat-form-field appearance="fill" style="display: flex;" subscriptSizing="dynamic">
        <!-- <mat-label>Search</mat-label> -->
        <input matInput type="text" name="table_search" (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>

    <div class="table-responsive">
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box"
            [fullScreen]="false">
            <p style="color: white"> Loading... </p>
        </ngx-spinner>
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Sr.No </th>
                <td mat-cell *matCellDef="let element"> {{element.srNo}} </td>
            </ng-container>

            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Category </th>
                <td mat-cell *matCellDef="let element"> {{element.category}} </td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd>
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <!-- <th mat-header-cell *matHeaderCellDef > Action </th> -->
                <td mat-cell *matCellDef="let element" style="white-space: nowrap;">
                    <button type="submit" mat-raised-button style="background: #F29F05;margin-right: 10px;"
                        (click)="EditScanningPoint(element.category_id)" matTooltip="Edit">
                        <mat-icon class=" m-0">edit</mat-icon>
                    </button>
                    <button type="submit" mat-raised-button style="background: #E02900;"
                        (click)="DeleteCategory(element.category_id)" matTooltip="Delete">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        </table>
    </div>
    <mat-paginator [showFirstLastButtons]="true" [length]="100" [pageSize]="100" [pageSizeOptions]="[150, 200, 250]"
        aria-label="Select page">
    </mat-paginator>
</div>